<template>
<div
	v-show="visible"
	class="list-group context-menu"
	:style="menuStyle"
	ref="contextMenu"
>
	<div class="list-group-item list-group-item-dark">
		<span class="fw-bold">Оберіть об'єкт, щоб розмістити</span>
	</div>

	<span
		v-if="!accountStore.permissions.includes('manage_stations')"
		class="fst-italic text-decoration-underline mx-2 my-1"
	>
		Вашого доступу недостатньо
	</span>

	<span
		v-if="accountStore.permissions.includes('manage_stations') && items.length == 0"
		class="fst-italic text-decoration-underline mx-2 my-1"
	>
		Всі активні станції вже розміщено
	</span>

	<button
		v-for="item in items"
		:key="item.id"
		type="button"
		class="list-group-item list-group-item-action"
		:class="{
			'disabled': !accountStore.permissions.includes('manage_stations'),
			'btn': !accountStore.permissions.includes('manage_stations'),
			'btn-outline-light': !accountStore.permissions.includes('manage_stations')
		}"
		@click="handleItemClick(item)"
	>
	<span class="text-body-secondary text-body-tertiary">{{ item.type }}&nbsp;</span>{{ item.title }}
	</button>
</div>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore'

export default {
	props: {
		position: Object,
		visible: Boolean,
		items: Array[Object],
		onItemClick: Function,
	},

	methods: {
		handleItemClick(item) {
			this.onItemClick(item);
		},
	},

	setup() {
		const width = 300;
		const height = 200;
		const accountStore = useAccontStore()

		return {
			width,
			height,
			accountStore,
		}
	},

	computed: {
		menuStyle() {
			const style = {
				top: `${this.position.top}px`,
				left: `${this.position.left}px`,
				"max-width": `${this.width}px`,
				"max-height": `${this.height}px`,
			};

			// Отримання розмірів вікна браузера
			const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
			//console.log(`Window size: width = ${windowWidth}, height = ${windowHeight}`)

			// Перевірка, чи меню виходить за межі вікна знизу або справа
			if (this.position.top + this.height > windowHeight) {
				style.top = `${this.position.top - this.height}px`;
			}

			if (this.position.left + this.width > windowWidth) {
				style.left = `${this.position.left - this.width}px`;
			}

			return style;
		},
	},
};
</script>


<style scoped>
.context-menu {
	/* display: none; */
	position: absolute;
	background-color: #fff;
	border: 1px solid #ccc;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	z-index: 1000;

	font-family: Roboto, Helvetica, Arial, sans-serif;
	/* font-size:small; */
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;

	overflow-y: auto; /* Додаємо прокрутку по вертикалі при необхідності */
}
</style>
